// Documents API endpoints

export const getDocumentsUrl = (businessKey: string): string => {
  return `/documents/${businessKey}`;
};

export const getDocumentDownloadUrl = (documentId: string): string =>
  `/documents/${documentId}/download`;

export const getDocumentPreviewUrl = (documentId: string): string =>
  `/documents/${documentId}/preview`;
